// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Raghav",
  middleName: "",
  lastName: "Gaggar",
  message: "Passionate about changing the world into a better place using Artificial Intelligence and Data Science",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/27rg5",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/raghav-gaggar/",
    },
  
  ],
};

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/my_img.jpg"),
  imageSize: 375,
  message:
    "My name is Raghav Gaggar. I graduated from the MS in Computer Science program in December 2023 from the University of Southern California. I was also working previously as a Machine Learning Data Scientist at the Zilkha Neurogenetic Institute.",
  resume: "https://drive.google.com/file/d/1qJMxTpUztuZwYtpcOGP1wpxP101Dd8rM/view?usp=drive_link",
};

const education = {
  show: true,
  heading: "Education",
  data: [
    {
      uni: "University of Southern California",
      role: 'Master of Science - Computer Science',
      companylogo: require('../assets/img/USC.png'),
      gpa: '3.5/4.0',
      courses: ["Artificial Intelligence", "Machine Learning for Data Science", "Database Systems", "Analysis of Algorithms", "Deep Learning", "Natural Language Processing", "Autonomous Cyber-Physical Systems"],
      date: 'January 2022 – December 2023',
    },
    {
      uni: "MIT - World Peace University",
      role: 'Bachelor of Technology - Computer Science & Engineering',
      companylogo: require('../assets/img/MITWPU.png'),
      gpa: '9.1/10.0',
      courses: ["Applied Mathematics", "Discrete Mathematics", "Data Structures", "Design & Analysis of Algorithms", "Operating Systems", "Computer Networks, Artificial Intelligence", "Machine Learning", "Cognitive Computing & Natural Language Processing", "Deep Learning", "Big Data Analytics", "Data Science", "Soft Computing", "Operations Research"],
      date: 'July 2017 – July 2021',
    },
  ]
}

const project = {
  show: true,
  heading: "Projects",
  data: [
    {
      title: "Text Summarization",
      description: "Performed LoRA fine-tuning, RLHF alignment and built a RAG system for dialogue summarization.",
      img: require('../assets/img/summarization.jpg'),
      stack: "Skills: Python, PyTorch, LLMs, Generative AI, Reinforcement Learning, Retrieval Augmented Generation, LangChain, HuggingFace, Gradio",
      url: "https://huggingface.co/spaces/raghav-gaggar/Text_Summarizer",
    },
    {
      title: "Intelligent bot for GO game",
      description: "AI bot built from scratch to play the GO game on a 5x5 board.",
      img: require('../assets/img/go_game.png'),
      stack: "Skills: Python, AI",
      url: "https://github.com/27rg5/AI-bot-for-GO-game",
    },
    {
      title: "Sequence Labeling",
      description: "Developed deep learning models for Named Entity Recognition using the CoNLL-2003 dataset.",
      img: require('../assets/img/NER.jpg'),
      stack: "Skills: Python, NLTK, PyTorch, NLP, DL",
      url: "https://github.com/27rg5/Sequence-Labeling",
    },
    {
      title: "HMM from scratch",
      description: "Hidden Morkov Model using Greedy and Viterbi algorithms from scratch.",
      img: require('../assets/img/hmm.png'),
      stack: "Skills: Python, NLP, ML",
      url: "https://github.com/27rg5/Hidden-Markov-Model-from-scratch",
    },
    {
      title: "Emotion Recognition",
      description: "Analyzed the sentiments of 60k Amazon reviews by predicting their star ratings through Deep Learning.",
      img: require('../assets/img/sentiment1.jpeg'),
      stack: "Skills: Python, Scikit-learn, PyTorch, NLP, ML, DL",
      url: "https://github.com/27rg5/Sentiment-Analysis-using-Deep-Learning",
    },
    {
      title: "Emotion Analysis",
      description: "Analyzed the sentiments of 603k reviews of Amazon appliances through Machine Learning. Also created a dashboard-based front-end with Flask to aid CRUD operations and display results.",
      img: require('../assets/img/sentiment.png'),
      stack: "Skills: Python, Scikit-learn, DBMS, MapReduce, Flask, D3.js, Big Data/Big Data Analysis",
      url: "https://github.com/27rg5/Sentiment-Analysis-using-Machine-Learning",
    },
    {
      title: "Automatic Colorization of Images using Autoencoders",
      description: "Program to colorize grayscale images to Lab color space with Convolutional Autoencoders.",
      img: require('../assets/img/cv.png'),
      stack: "Skills: Python, OpenCV, Keras/TensorFlow, CV, DL",
      url: "https://github.com/27rg5/Automatic-Colorization-of-Images-using-Autoencoders",
    },
    {
      title: "Humanoid Robotics",
      description: "Program to make the humanoid robot – NAO, competent to serve as a companion to and entertain elderly people. The project's success made me an instructor of the humanoid robotics course in my undergraduate university, where I taught 70+ students. We also demonstrated this project at many big events like the INDCON 2019, where we received appreciation from a Union Minister of India.",
      img: require('../assets/img/full-nao1.png'),
      stack: "Skills: Python, Choregraphe tool, ML",
      url: "https://github.com/27rg5/Humanoid-Robotics",
    },
    {
      title: "Neural Machine Translator",
      description: "Hebrew to English language translator using a sequence-to-sequence deep learning model.",
      img: require('../assets/img/nmt.png'),
      stack: "Skills: Python, Keras/TensorFlow, NLP, DL",
      url: "https://github.com/27rg5/Neural-Machine-Translation",
    },
    {
      title: "Search Engine Optimization",
      description: "Program consisting of a web crawler and a keywords suggestion script to increase the inbound traffic to websites.",
      img: require('../assets/img/seo.jpg'),
      stack: "Skills: Python, AI",
      url: "https://github.com/27rg5/Search-Engine-Optimization",
    },
    {
      title: "Age and Gender Estimation",
      description: "Application to estimate the age and gender of a person through an image using deep learning.",
      img: require('../assets/img/age_gender.jpg'),
      stack: "Skills: Python, Keras/TensorFlow, NLP, DL",
      url: "https://github.com/27rg5/Age-and-Gender-Estimation",
    },
  ]
}

const publication = {
  show: true,
  heading: "Publications",
  data: [
    {
      title: "Extraction and Summarization of Explicit Video Content using Multi-Modal Deep Learning",
      url: "https://arxiv.org/abs/2311.10899",
    },
    {
      title: "Machine-Generated Text Detection using Deep Learning",
      url: "https://arxiv.org/abs/2311.15425",
    },
    {
      title: "Electroencephalogram Based Depression Assessment Using Machine and Deep Learning Techniques: A Survey",
      url: "http://doi.one/10.1729/Journal.24918",
    },
  ]
}

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Top Technical Skills",
  hardSkills: [
    { name: "Python", value: 90 },
    { name: "Data Structures and Algorithms", value: 90 },
    { name: "Git,Docker", value: 90 },
    { name: "SQL,NoSQL", value: 90 },
    { name: "HTML,CSS,JavaScript,Node.js,PHP,Bootstrap,Flask,Gradio,D3.js", value: 70 },
    { name: "Java", value: 60 },
    { name: "Microsoft Azure Databricks, MLflow", value: 70 },
    { name: "Hive,Hadoop", value: 50 },
  ],
  hardSkills1: [
    { name: "ML/DL: PyTorch,Keras,TensorFlow,Scikit-learn,Transformers", value: 95 },
    { name: "CV/NLP: LLMs,LangChain,OpenCV,NLTK,spaCy", value: 95 },
    { name: "Misc: Generative AI,ONNX,TensorRT,XGBoost,PySpark", value: 95 },
    { name: "Mathematics and Statistics", value: 95 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "I am looking for full-time opportunities in AI/Data Science/Software Engineering! If you know of any positions available, or if you want to discuss anything related to these fields, please feel free to email me at",
  email: "gaggar99@gmail.com/gaggar@usc.edu",
};

const experiences = {
  show: true,
  heading: "Experiences",
  data: [
    {
      company: "Zilkha Neurogenetic Institute",
      role: 'Data Scientist: Machine Learning',
      companylogo: require('../assets/img/USC.png'),
      stack: "Skills: Python, Keras/TensorFlow, Docker, Computer Vision, Deep Learning, Statistics, Data Analysis",
      work_done1: "- Analyzed human brain DCE-MRI images in order to study Alzheimer's disease.",
      work_done2: "- Designed, trained, optimized, and deployed 3D computer vision models for segmenting specific brain regions.",
      work_done3: "- Programmed Python and Bash scripts to process big datasets of size more than 300 GB.",
      work_done4: "- Developed a Python script that reduced noise/fluctuations in DCE-MRI images by over 70%.",
      date: 'June 2022 – Present',
      url: `${process.env.PUBLIC_URL}/research.html`,
    },
    {
      company: "NVIDIA",
      role: 'Machine Learning Research Intern',
      companylogo: require('../assets/img/Nvidia.png'),
      stack: "Skills: Python, Keras/TensorFlow, PyTorch, OpenCV, Docker, Computer Vision, Generative AI",
      work_done1: "- Researched the generation of human faces through their voice using deep learning techniques.",
      work_done2: "- Designed and implemented a novel Generative Adversarial Network to generate the colored facial images of people, and a CNN to identify the generated images, in Python.", 
      work_done3: "- Coded the networks in both PyTorch and TensorFlow frameworks. Preprocessed the data with OpenCV, and used NVIDIA DALI for faster preprocessing in TensorFlow. Optimized my pipeline in the PyTorch version, which improved training speed by 75%.",
      date: 'August 2021 – April 2022',
      url: 'https://github.com/27rg5/NVIDIA-internship',
    },
    {
      company: "AlgoAsylum",
      role: 'Research Intern: Data Science',
      companylogo: require('../assets/img/algoasylum.jpg'),
      stack: "Skills: Python, Scikit-learn, Machine Learning, Statistics, Signal Processing, Data Analysis, SQL, NoSQL",
      work_done1: "- Researched the correlation of the luminosity of an area with its economic prosperity through night-light satellite images using Python. Presented a part of this work at PyCon India 2020.",
      work_done2: "- Performed many signal processing and statistical experiments in Python to characterize rainfall patterns of the Indian Monsoon using last 21 years’ satellite data. Achieved it with Gaussian Mixture Models, Wasserstein distance, and Jaccard distance.",
      date: 'June 2020 – July 2021',
      url: 'https://github.com/algoasylum/SatelliteImageAnalysis',
    },
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, education, project, publication, skills, getInTouch, experiences };
